import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Dom } from '../utils/dom';
import { ApplicationStoreService } from './application-store.service';
import { WordService } from './word.service';
import { XmlPrettyPrintService } from './xml-pretty-print.service';

@Injectable({ providedIn: 'root' })
export class DebugService {

  private showDebugPanel: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showDebugPanel$: Observable<boolean> = this.showDebugPanel.asObservable();

  constructor(
    private applicationStoreService: ApplicationStoreService,
    private wordService: WordService,
    private xmlPrettyPrintService: XmlPrettyPrintService
  ) {}

  toggleDebugPanel(): void {
    this.showDebugPanel.next(!this.showDebugPanel.value);
  }

  async dumpObjectAtSelection(context: Word.RequestContext): Promise<void> {
    const range = context.document.getSelection();
    context.load(range);
    range.contentControls.load(['id']);
    context.document.body.contentControls.load();
    // context.document.body.paragraphs.load();
    await context.sync();
    console.log('range isEmpty=', range.isEmpty);
    console.log('range.cc', range.contentControls.items);
    console.log('doc.body.cc', context.document.body.contentControls.items);

    const allDocXml = range.getOoxml();
    console.log('sync to get range ooxml');
    await context.sync();
    console.log('sync success');
    // console.log(allDocXml.value);
    const dom = new Dom(allDocXml.value);
    const body = dom.documentElement.getElementsByTagName('w:body');
    console.log('sel range xml body', body[0]);
  }

  async dumpModel(context: Word.RequestContext, namespace: string): Promise<void> {
    const nss = await this.applicationStoreService.getNamespaceSettings(namespace);
    if (!nss) {
      console.log('Could not find the model for this namespace.');
    } else {
      const nsp = await this.applicationStoreService.getNamespacePart(nss);
      const part = await this.wordService.getCustomXmlPart(nsp.model.id);
      let xml = await part.getXml();
      let dom = new Dom(xml);
      console.log('MODEL', this.xmlPrettyPrintService.processXml(dom.outerHTML));

      const xpath = await this.wordService.getCustomXmlPart(nsp.dopeXPaths.id);
      xml = await xpath.getXml();
      dom = new Dom(xml);
      console.log('DOPE-XPATH', this.xmlPrettyPrintService.processXml(dom.outerHTML));

      const conds = await this.wordService.getCustomXmlPart(nsp.dopeConditions.id);
      xml = await conds.getXml();
      dom = new Dom(xml);
      console.log('DOPE-CONDS', this.xmlPrettyPrintService.processXml(dom.outerHTML));

      const serverModel = nss.jsonModel;
      console.log('SERVER-MODEL', JSON.stringify(serverModel));

      const functions = nss.functions;
      console.log('FUNCTIONS', functions ? JSON.stringify(functions) : 'NONE');
    }

    const contentControlToFieldMap = this.applicationStoreService.get('kp-ccid-to-field');
    console.log('CC-TO-FIELD-MAP', contentControlToFieldMap);

    const contentControlToFieldMapV1 = this.applicationStoreService.get('kp-field-contexts-v1');
    console.log('FIELD-CONTEXTS-V1', contentControlToFieldMapV1);

    const signatureFields = this.applicationStoreService.get('kp-signature-fields-v1');
    console.log('SIGNATURE-FIELDS', signatureFields);
  }

  async dumpAddInInfo(context: Word.RequestContext): Promise<void> {
    const info: any = JSON.parse(JSON.stringify(this.applicationStoreService.getAddInInfo()));
    info.createDate = new Date(info.createDate);
    console.log('Info', info);
  }

  async dumpContentControls(context: Word.RequestContext): Promise<void> {
    const contentControls = context.document.contentControls.load(['id', 'tag', 'title', 'parentContentControlOrNullObject']);
    await context.sync();

    if (contentControls.items.length === 0) {
      console.log('No content controls.');
      return;
    }

    console.log(
      'CONTROLS',
      contentControls.items.map((cc) => ({
        id: cc.id,
        tag: cc.tag,
        title: cc.title,
        parent: cc.parentContentControlOrNullObject.isNullObject ? null : cc.parentContentControlOrNullObject.id,
      }))
    );
  }
}
